import {StyleSheet} from 'react-native';

import {black, cloudLight, onyx, white} from '/theme/color/on.color';
import {pine} from '/theme/color/primary.color';

export const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    justifyContent: 'flex-end',
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  backdropPressable: {
    flex: 1,
  },
  bottomSheet: {
    backgroundColor: white,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingBottom: 20,
    width: '100%',
    shadowColor: black,
    shadowOffset: {width: 0, height: -2},
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 20,
    maxHeight: '90%',
  },
  scrollContainer: {
    flexGrow: 0,
  },
  header: {
    paddingTop: 16,
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: onyx,
    marginBottom: 16,
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: cloudLight,
  },
  content: {
    paddingHorizontal: 10,
    paddingTop: 8,
  },
  optionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
  },
  leftContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconWrapper: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: '#F4F6F8',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    borderWidth: 1,
    borderColor: '#DFE3E8',
  },
  browserIconWrapper: {
    backgroundColor: white,
  },
  appIcon: {
    width: 32,
    height: 32,
  },
  browserIcon: {
    width: 32,
    height: 32,
  },
  optionText: {
    fontSize: 16,
    fontWeight: '500',
    color: onyx,
  },
  openButton: {
    backgroundColor: pine, // Reddit Blue
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 20,
    minWidth: 80,
    alignItems: 'center',
  },
  openButtonText: {
    color: white,
    fontSize: 14,
    fontWeight: '700',
  },
  continueButton: {
    backgroundColor: white,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#878A8C',
    minWidth: 80,
    alignItems: 'center',
  },
  continueButtonText: {
    color: '#878A8C',
    fontSize: 14,
    fontWeight: '700',
  },
});
